import CustomerReviewsAPI from '@/API/customer-reviews-api'

export default {
  namespaced: true,
  state: {
    fetched: false,
    noReviews: false,
  },

  getters: {
    noReviews: (state: any) => state.noReviews,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.noReviews = payload.noReviews ?? false
      state.fetched = true
    },
    RESET_FETCH(state: any) {
      state.fetched = false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any, force = false) {
      if (context.state.fetched && !force) {
        return
      }

      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await CustomerReviewsAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.log(err)
        throw err
      }
    },
    RESET_FETCH(context: any) {
      context.commit('RESET_FETCH')
    },
  },
}
